var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"10px 20px"}},[_c('span',{staticStyle:{"font-size":"20px"}},[_vm._v("众包服务")]),_c('p',{staticStyle:{"font-size":"14px","color":"#666666","text-align":"left"}},[_c('span',{staticStyle:{"margin-left":"20px"}}),_vm._v("日日顺众包服务，旨在搭建社会化服务的共享平台，师傅可自由选择加入平台，为用户，提供就近到家的安装、维修、清洗、同城配送等服务，帮助师傅提供单量，并提供更多机会和保障，实现社会化师傅的价值。")])])
}]

export { render, staticRenderFns }